import React from "react";
import PropTypes from "prop-types";
import { NavLink } from "react-router-dom";
import { sortBy, startCase } from "lodash";

const RecipeList = ({ recipes, favorites }) => {
  // currently unused
  const renderCookBookKey = () => {
    return (
      <div
        style={{
          width: "8em",
          border: "1px solid red",
        }}
      >
        <table>
          <thead>
            <tr>
              <th>Icon</th>
              <th>Meaning</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>
                <svg
                  width="1em"
                  height="1em"
                  viewBox="0 0 16 16"
                  className="bi bi-heart-fill"
                  fill="currentColor"
                  xmlns="http://www.w3.org/2000/svg"
                  style={{
                    color: "#f4550b",
                  }}
                >
                  <path
                    fillRule="evenodd"
                    d="M8 1.314C12.438-3.248 23.534 4.735 8 15-7.534 4.736 3.562-3.248 8 1.314z"
                  />
                </svg>
              </td>
              <td>Favorite</td>
            </tr>
            <tr>
              <td>WIP</td>
              <td>Work in progress</td>
            </tr>
          </tbody>
        </table>
      </div>
    );
  };
  const renderRecipes = (recipes) => {
    const newRecipes = sortBy(recipes, (recipe) => startCase(recipe.title));

    return newRecipes.map((recipe) => {
      let ingredients = [];
      if (recipe.ingredientList) {
        ingredients = recipe.ingredientList.map((ingredient, idx) => {
          if (recipe.ingredientList.length === idx + 1) {
            return <span key={ingredient[0]}>{ingredient[0]}</span>;
          }
          return <span key={ingredient[0]}>{ingredient[0]}</span>;
        });
      }

      return (
        <div key={recipe.title} className="recipeCard">
          {favorites.includes(recipe._id) ? (
            <div
              className="heart-filled"
              style={{
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
              }}
            >
              <svg
                width="1em"
                height="1em"
                viewBox="0 0 16 16"
                className="bi bi-heart-fill"
                fill="currentColor"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fillRule="evenodd"
                  d="M8 1.314C12.438-3.248 23.534 4.735 8 15-7.534 4.736 3.562-3.248 8 1.314z"
                />
              </svg>
              <h4 className="viewTitle" style={{ marginLeft: "0.25em" }}>
                <NavLink to={`/cookbook/recipe/${recipe._id}`}>
                  {recipe.title}
                </NavLink>
              </h4>
            </div>
          ) : (
            <h4 className="viewTitle">
              <NavLink to={`/cookbook/recipe/${recipe._id}`}>
                {recipe.title}
              </NavLink>
            </h4>
          )}

          <p>difficulty: {recipe.difficulty}</p>
          {ingredients.length ? (
            <div className="ingredientSection">
              <p>ingredients:</p>
              <div className="ingredientList">{ingredients}</div>
            </div>
          ) : null}
        </div>
      );
    });
  };

  return (
    <div className="results">
      <div className="recipeCard">
        <div className="recipePageTitle zigzag" />
      </div>
      <div className="listAllMeals">{renderRecipes(recipes)}</div>
    </div>
  );
};

RecipeList.propTypes = {
  recipes: PropTypes.array.isRequired,
  favorites: PropTypes.array,
  selectRecipe: PropTypes.func,
};

export default RecipeList;
